import { render, staticRenderFns } from "./CreateSoftwareAddServiceModal.vue?vue&type=template&id=183f931c&scoped=true&"
import script from "./CreateSoftwareAddServiceModal.vue?vue&type=script&lang=js&"
export * from "./CreateSoftwareAddServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSoftwareAddServiceModal.vue?vue&type=style&index=0&id=183f931c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f931c",
  null
  
)

export default component.exports